import { Divider, Form, Input, Modal, Row } from 'antd'
import { ItemData } from '../ItemData'
import { ContractDetail, ServiceContract } from 'src/common/models/contract'
import { Col24 } from 'src/components/Columns'
import { getInputRequiredRule } from 'src/common/util'
import { FormActionButtons } from 'src/components/FormActionButtons'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'src/state/reducer'
import { updateCurrentContract } from 'src/features/ServiceContract/state/action'
import { useEffect } from 'react'
import { SystemDescriptions } from 'src/common/descriptions'

interface Props {
    open: boolean
    onCancel: VoidFunction
    onAccept: VoidFunction
    okText: string
    cancelText: string
    itemDetail: ContractDetail
}

export type ReduxProps = {
    currentContract?: Partial<ServiceContract>
}

export const DescriptionModal = (props: Props) => {
    const dispatch = useDispatch();

    const descriptions = SystemDescriptions.PAGES.SERVICE_CONTRACT.CREATE_SERVICE_CONTRACT

    const [form] = Form.useForm();

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        currentContract: state.serviceContract.currentContract,
    }))

    useEffect(() => {
        form.setFieldsValue({
            description: props.itemDetail.serviceName,
        })
    }, [])

    const onFinish = (formValues) => {

        const newDetail = reduxProps.currentContract?.detail?.map(item => {
            if (item.ref === props.itemDetail.ref) {
                item.serviceName = formValues.description
            }
            return item
        })

        dispatch(updateCurrentContract({
            detail: newDetail,
        }))

        props.onAccept()
    }

    const renderForm = () => {
        return <Form
            form={form}
            layout="vertical"
            requiredMark={false}
            autoComplete={'none'}
            onFinish={onFinish}
        >
            <Row gutter={[16, 8]}>
                <Col24>
                    <Form.Item
                        label={descriptions.DESCRIPTION.LABEL}
                        name={"description"}
                        rules={[
                            getInputRequiredRule(descriptions.DESCRIPTION.LABEL),
                        ]}
                        validateTrigger="onBlur"
                    >
                        <Input
                            placeholder={descriptions.DESCRIPTION.PLACEHOLDER}
                            maxLength={35}
                            showCount
                        />
                    </Form.Item>
                </Col24>
                <Col24>
                    <FormActionButtons
                        cancelText={descriptions.DESCRIPTION.CANCEL}
                        actionText={descriptions.DESCRIPTION.ACCEPT}
                        onCancel={() => {
                            form.setFieldsValue({
                                price: props.itemDetail.price,
                            })
                            props.onCancel()
                        }}
                    />
                </Col24>
            </Row>
        </Form>
    }

    return (
        <Modal
            title={descriptions.DESCRIPTION.TITLE}
            centered
            open={props.open}
            width={600}
            onOk={props.onAccept}
            okText={props.okText}
            cancelText={props.cancelText}
            footer={<></>}
            closable={false}
            zIndex={1200}
            getContainer={false}
        >
            <ItemData itemDetail={props.itemDetail} />
            <Divider />
            {renderForm()}
        </Modal>
    )
}
